import { styled } from '@mui/material';
import { Box } from '@mui/system';
import FlexBox from 'components/flexbox/FlexBox';
import { H5 } from 'components/Typography';

const Wrapper = styled(Box)(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
}));

const HeadingArea = ({}) => {
    return (
        <Wrapper gap={1}>
            <FlexBox alignItems="center">
                <H5>Abstract To Score</H5>
            </FlexBox>
        </Wrapper>
    );
};

export default HeadingArea;
